module.exports = __webpack_public_path__ + "c1bc69b866e5ae6257210508b86afd9b.svg";